import { useMediaQuery } from '@material-ui/core';
import Box from '@material-ui/core/Box';
import messages from 'components/ContainerTabs/messages';
import { StyledTab, StyledTabs } from 'components/ContainerTabs/styles';
import GATracking, { EVENT_ACTION } from 'helpers/GATracking';
import { translate } from 'helpers/intl';
import { get } from 'lodash';
import React, { useEffect } from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { breadcrumbsItemType } from 'store/global/types';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`container-tabpanel-${index}`}
      aria-labelledby={`container-tab-${index}`}
      {...other}
    >
      {value === index && <Box p={3}>{children}</Box>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `container-tab-${index}`,
    'aria-controls': `container-tabpanel-${index}`,
  };
}

export interface tabItemProps {
  label: string;
  content: React.ReactNode;
  gaLabel?: string;
  category?: string;
}

const ContainerTabs = (props: {
  tabItems: tabItemProps[];
  setBreadcrumbsPath?: Function;
  intl: IntlShape;
  rootPath: breadcrumbsItemType[];
  selectedTabValue: number;
}) => {
  const isNotMobile = useMediaQuery('(min-width:960px)');

  useEffect(() => {
    try {
      window.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth',
      });
    } catch (error) {
      /* istanbul ignore next */
      window.scrollTo(0, 0);
    }
  }, [props.selectedTabValue]);

  const getLabel = (label: string) => {
    if (label === 'suiviPAC' && !isNotMobile) {
      /* istanbul ignore next */
      return translate(messages.suiviPACResp, props);
    } else if (label === 'suiviDesDemandes' && !isNotMobile) {
      /* istanbul ignore next */
      return translate(messages.suiviDesDemandesResp, props);
    }
    return translate(get(messages, label), props);
  };

  return (
    <>
      <StyledTabs
        value={props.selectedTabValue}
        aria-label="container tabs"
        variant="fullWidth"
      >
        {props.tabItems.map((tab: tabItemProps, index) => {
          return (
            <StyledTab
              key={index}
              label={getLabel(tab.label)}
              {...a11yProps(index)}
              onClick={() => {
                if (tab.category && tab.gaLabel) {
                  GATracking.event(
                    tab.category,
                    EVENT_ACTION.CLICK,
                    tab.gaLabel,
                  );
                }
                props.setBreadcrumbsPath &&
                  props.setBreadcrumbsPath([
                    ...props.rootPath,
                    { name: tab.label, route: index },
                  ]);
              }}
            />
          );
        })}
      </StyledTabs>
      {props.tabItems.map((tab: tabItemProps, index) => (
        <TabPanel key={index} value={props.selectedTabValue} index={index}>
          {tab.content}
        </TabPanel>
      ))}
    </>
  );
};

export default injectIntl(ContainerTabs);
